import css from './style.module.scss';
import Wrap from '../Wrap';
import A from '../A';
import { gql } from '../../util/fetchGql';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import Prose from '../Prose';

export const FAQS_CATEGORY_FRAGMENT = gql`
	fragment FaqsCategory on faqCategory_Category {
		id
		title
		uri
	}
`;

export const FAQS_ENTRY_FRAGMENT = gql`
	fragment FaqsEntry on faq_default_Entry {
		id
		title
		text
	}
`;

export default function FaqsContent ({ categories, entries }) {
	const router = useRouter();

	return (
		<Wrap grid className={css.wrap}>
			<aside className={css.aside}>
				{categories?.map(cat => (
					<A
						key={cat.id}
						href={`/${cat.uri}`}
						className={router.asPath.split('#')[0] === `/${cat.uri}` ? css.active : ''}
					>
						{cat.title}
					</A>
				))}
			</aside>
			<div className={css.content}>
				<dl>
					{entries?.map(entry => (
						<Fragment key={entry.id}>
							<dt>{entry.title}</dt>
							<Prose El="dd">{entry.text}</Prose>
						</Fragment>
					))}
				</dl>
			</div>
		</Wrap>
	);
}
